import { prop,propObject,propArray,required,maxLength,range  } from "@rxweb/reactive-form-validators"
import { gridColumn } from "@rxweb/grid"


export class vRFQRecordBase {

//#region projectRFQId Prop
        @gridColumn({visible: true, columnIndex:0, allowSorting: true, headerKey: 'projectRFQId', keyColumn: true})
        projectRFQId : number;
//#endregion projectRFQId Prop


//#region projectId Prop
        @gridColumn({visible: true, columnIndex:1, allowSorting: true, headerKey: 'projectId', keyColumn: false})
        projectId : number;
//#endregion projectId Prop


//#region projectName Prop
        @gridColumn({visible: true, columnIndex:2, allowSorting: true, headerKey: 'projectName', keyColumn: false})
        projectName : string;
//#endregion projectName Prop


//#region hRConsultant Prop
        @gridColumn({visible: true, columnIndex:3, allowSorting: true, headerKey: 'hRConsultant', keyColumn: false})
        hRConsultant : number;
//#endregion hRConsultant Prop


//#region hRConsultantName Prop
        @gridColumn({visible: true, columnIndex:4, allowSorting: true, headerKey: 'hRConsultantName', keyColumn: false})
        hRConsultantName : string;
//#endregion hRConsultantName Prop


//#region hROName Prop
        @gridColumn({visible: true, columnIndex:5, allowSorting: true, headerKey: 'hROName', keyColumn: false})
        hROName : string;
//#endregion hROName Prop


//#region projectRFQStatus Prop
        @gridColumn({visible: true, columnIndex:6, allowSorting: true, headerKey: 'projectRFQStatus', keyColumn: false})
        projectRFQStatus : number;
//#endregion projectRFQStatus Prop


//#region createdOn Prop
        @gridColumn({visible: true, columnIndex:7, allowSorting: true, headerKey: 'createdOn', keyColumn: false})
        createdOn : any;
//#endregion createdOn Prop


//#region createdBy Prop
        @gridColumn({visible: true, columnIndex:8, allowSorting: true, headerKey: 'createdBy', keyColumn: false})
        createdBy : number;
//#endregion createdBy Prop

}